export const useVideoBlockMp4 = () => {
    document.querySelectorAll(".video-block__content--mp4").forEach(element => {
        const blockElement = element as HTMLElement;

        if (blockElement.dataset.initializedMedia === "true") {
            return;
        }

        const video = blockElement.querySelector("video.video-block__player") as HTMLVideoElement | null;
        const playBtn = blockElement.querySelector(".video-block__icon") as HTMLElement | null;
        const imageWrapper = blockElement.querySelector(".video-block__image-wrapper") as HTMLElement | null;

        if (video && playBtn) {
            playBtn.addEventListener("click", () => {
                // Hide overlay image
                if (imageWrapper) {
                    imageWrapper.style.display = "none";
                }

                // Show video player
                video.style.display = "block";

                // Hide play button
                playBtn.style.display = "none";

                // Add CSS class if needed for styling
                blockElement.classList.add("video-block__content--show-video");
                // Recalculate video height
                window.dispatchEvent(new Event("resize"));
                // Play video
                video.play();
            });

            video.addEventListener("play", () => {
                blockElement.classList.add("video-block__content--show-video");
                playBtn.style.display = "none";
            });

            video.addEventListener("ended", () => {
                // Reset overlay after video ends
                if (imageWrapper) {
                    imageWrapper.style.display = "block";
                }
                playBtn.style.display = "block";
                blockElement.classList.remove("video-block__content--show-video");
                video.style.display = "none";
                video.currentTime = 0;
            });
        }

        blockElement.dataset.initializedMedia = "true";
    });
};